import React from 'react';

interface VariantLabelFieldsProps {
  flavorLabel: string;
  packageLabel: string;
  salesDesignation: string;
  ean: string;
  lehUnitPrice: string;
  onChange: (patch: {
    flavor_label?: string;
    package_label?: string;
    sales_designation?: string;
    ean?: string;
    leh_unit_price_net?: string;
  }) => void;
}

const inputClass =
  'w-full p-2.5 border-2 border-gray-200 rounded-xl text-sm font-bold focus:border-brand-500';

export const VariantLabelFields: React.FC<VariantLabelFieldsProps> = ({
  flavorLabel,
  packageLabel,
  salesDesignation,
  ean,
  lehUnitPrice,
  onChange,
}) => (
  <>
    <div className="col-span-2 pt-1">
      <p className="text-xs text-gray-400 mb-2">
        Flavour and pack size are listed separately in customer emails.
        Without them the raw Gebinde name is used.
      </p>
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 mb-1 block">Flavour label</label>
      <input
        value={flavorLabel}
        onChange={(e) => onChange({ flavor_label: e.target.value })}
        placeholder="e.g. Sicilian Lemon"
        className={inputClass}
      />
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 mb-1 block">Pack label</label>
      <input
        value={packageLabel}
        onChange={(e) => onChange({ package_label: e.target.value })}
        placeholder="e.g. 24 x 0,33 l Dose"
        className={inputClass}
      />
    </div>
    <div className="col-span-2">
      <label className="text-xs font-bold text-gray-500 mb-1 block">Bezeichnung</label>
      <input
        value={salesDesignation}
        onChange={(e) => onChange({ sales_designation: e.target.value })}
        placeholder="Legal sales name on supermarket delivery notes"
        className={inputClass}
      />
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 mb-1 block">LEH net / unit</label>
      <input
        type="number"
        min={0.01}
        step={0.01}
        value={lehUnitPrice}
        onChange={(e) => onChange({ leh_unit_price_net: e.target.value })}
        placeholder="Empty = same price for every channel"
        className={inputClass}
      />
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 mb-1 block">EAN</label>
      <input
        value={ean}
        inputMode="numeric"
        onChange={(e) => onChange({ ean: e.target.value })}
        placeholder="8–14 digits"
        className={inputClass}
      />
    </div>
  </>
);
